// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"b34845c3","253":"278bfa21","300":"33d97ca3","310":"564ee0e4","381":"52c504fc","635":"23d0a27b","664":"35dd7be1","673":"ecde0da6","719":"a86be5b2","722":"90f615d9"}[chunkId] + ".chunk.js";
};